import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageBilbao = props => {
  return <CityLandingPage cityKey="Bilbao" cityConfig={cityContent.bilbao} {...props} />;
};

export default LandingPageBilbao;
